// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__3Qne-","shortcutHint":"QuestionChoices_shortcutHint__2jQgU"};